import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class BottomBar extends Component {
  view() {
    const isBottomEnabled = !!app.forum.attribute('modern-footer.bottom-enabled');
    const copyright = app.forum.attribute('modern-footer.copyright');
    return isBottomEnabled && m("div", {
      class: "foo-bottom"
    }, m("p", null, copyright || ''));
  }
}
flarum.reg.add('huseyinfiliz-modern-footer', 'forum/components/BottomBar', BottomBar);